"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = void 0;
// ButtonToggleStyles.ts
const css_in_js_1 = require("../../components/css-in-js");
exports.styles = {
    buttonToggle: (0, css_in_js_1.css) `
        display: inline-flex;
        border-radius: 4px;
        gap: 8px;
        background: #f3f3f4;
    `,
    button: (0, css_in_js_1.css) `
        cursor: pointer;
        border-radius: 4px;
        border: solid 1px transparent;
        background: transparent;
        padding: 0;
    `,
    dcButton: (0, css_in_js_1.css) `
        background-color: transparent;
        border-color: transparent;
        text-transform: none;
        cursor: pointer;
        border-radius: 4px;
        border: none;
        padding: 3px 7px;
    `,
    buttonHover: (0, css_in_js_1.css) `
        background-color: #f6fbfe;
        font-weight: 600;
        color: #025b9c;
        cursor: pointer;
    `,
    selected: (0, css_in_js_1.css) `
        background-color: #fdfffc;
        border-color: #038bed;
        font-weight: 600;
        color: #025b9c;
    `,
    dcSelected: (0, css_in_js_1.css) `
        font-weight: 600;
        color: #025b9c;
    `,
    disabled: (0, css_in_js_1.css) `
        opacity: 0.5;
        cursor: not-allowed;
    `,
};
//# sourceMappingURL=ButtonToggleStyles.js.map